import { render, staticRenderFns } from "./CustomerCreditRefund.vue?vue&type=template&id=05881e6c&"
import script from "./CustomerCreditRefund.vue?vue&type=script&lang=js&"
export * from "./CustomerCreditRefund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports